import React, { useState } from "react";
import PropTypes from "prop-types";
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import { useHistory } from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { deletePaymentAccount } from "redux/actions/payment";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import BankACForm from "../BankACForm/index";
import DebitForm from "../DebitForm/index";
import VerifyModal from '../VerifyModal/index';
import TextInput from "web/components/form-elements/TextInput";
import AlertModal from "web/components/AlertModal";
import DeleteModal from '../DeleteModal';

import { getPostInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/promoCodeUtils";
import styled from "styled-components";
import AddCardPopup from "web/pages/private/CommonPages/ManageAccount/AddCardPopup";
import Delete from "web/assets/images/delete-icon.png";
import EditIcon from "web/assets/images/edit.png";

import VisaImage from "web/assets/images/dummy-visa-image.png";
import AmexCardIcon from "web/assets/images/amex-card-icon.png";
import DiscoverIcon from "web/assets/images/dummy-discover-card-icon.png";
import MastercardIcon from "web/assets/images/dummy-master-card-image.png";
import JCBCardIcon from "web/assets/images/jcb-card-icon.png";
import DinersCardIcon from "web/assets/images/diners-card-icon.png";
import UnionCardIcon from "web/assets/images/union_card_icon.png";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    background: "#2fb5f1",
  },

  AppBar: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none",
  },
  Tab: {
    textTransform: "capitalize",
    fontSize: "16px",
  },
}));

const PaymentTabs = ({ pageData, callBackFetchApi, pageLanguageContents, defaultPaymentCallBack, }) => {
  const classes = useStyles();
  const storedData = useSelector((state) => state.storedData.payload);
  let disableFlg = storedData?.guestUser

  let selectTab = 0
  if (disableFlg) {
    selectTab = 1
  }
  const [value, setValue] = React.useState(selectTab);

  const dispatch = useDispatch();
  let history = useHistory();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let brokerAccount = localStorage.getItem("brokerAccount");
  const [promoCodemodal, setPromoCodeModal] = useState(false);
  const promoCodeToggleModal = () => setPromoCodeModal(!promoCodemodal);

  const [deleteModal, setDeleteModal] = useState(false);
  const [modalDeleteLink, setModalDeleteLink] = useState('/');
  const toggleDeletModal = () => setDeleteModal(!deleteModal);
  const [deletePaymentId, setDeletePaymentId] = useState();
  const [actionType, setActionType] = useState();
  const [paymentType, setPaymentType] = React.useState();

  const accountType = localStorage.getItem("accountType");
  const formType = localStorage.getItem("formType");

  const [selectedAchAccountForVerify, setSelectedAchAccountForVerify] = useState()
  const [verifyModal, setVerifyModal] = useState(false);
  const verifyToggleModal = () => setVerifyModal(!verifyModal);

  const isCentralized = localStorage.getItem("isCentralizedPaymentMethod");
  const [addCardmodal, setAddCardmodal] = useState(false);
  const addCardToggleModal = () => setAddCardmodal(!addCardmodal);

  const [popupType, setPopupType] = useState();

  const [addDebitCardmodal, setAddDebitCardmodal] = useState(false);
  const addDebitCardToggleModal = () => setAddDebitCardmodal(!addDebitCardmodal);

  const [addBankCardmodal, setAddBankCardmodal] = useState(false);
  const addBankCardToggleModal = () => setAddBankCardmodal(!addBankCardmodal);

  const [accountResponse, setAccountResponse] = useState();
  const [individual, setIndividual] = useState();
  const handleChange = (event, newValue) => {
    if (disableFlg) {
      setValue(1);
    } else {
      setValue(newValue);
    }
  };

  const deletePaymentMethod = async (val) => {
    toggleDeletModal()
    const token = localStorage.getItem("token");
    let response = await dispatch(deletePaymentAccount(deletePaymentId, token));
    if (response.status === "SUCCESS") {
      callBackFetchApi();
      setModalContent(response.message);
      setModalLink('');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const deleteAccount = (type, value) => {
    return <div className="account-edit-icon" style={{ 'margin-left': '10px' }}
      onClick={() => {
        setActionType(type)
        setDeletePaymentId(value.id)
        toggleDeletModal()
      }}
    >
      <img
        src={Delete}
        alt="Delete"
        style={{ cursor: "pointer", width: "23px", marginleft: "10px", }}
        onClick={(e) => { }}
      ></img>
    </div>
  }

  const getCardImageSourceFunction = brandName => {
    if (brandName !== "" && brandName !== undefined) {
      if (brandName.toLowerCase() === 'visa') return VisaImage
      else if (brandName.toLowerCase() === 'mastercard') return MastercardIcon
      else if (brandName.toLowerCase() === 'amex') return AmexCardIcon
      else if (brandName.toLowerCase() === 'discover') return DiscoverIcon
      else if (brandName.toLowerCase() === 'diners') return DinersCardIcon
      else if (brandName.toLowerCase() === 'jcb') return JCBCardIcon
      else if (brandName.toLowerCase() === 'unionpay') return UnionCardIcon
      else return VisaImage
    }
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.AppBar}>
        <Tabs
          value={value}
          indicatorColor="primary"
          variant={"scrollable"}
          scrollButtons={"on"}
          classes={{
            indicator: classes.indicator,
          }}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          {!disableFlg && <Tab
            className={classes.Tab}
            label={pageLanguageContents?.Arrow_Payment[28]?.SellersRemittance}
            {...a11yProps(0)}
          />}
          <Tab
            className={classes.Tab}
            label={pageLanguageContents?.Arrow_Payment[29]?.BuyerPayment}
            {...a11yProps(1)}
          />
          {!disableFlg && <Tab
            className={classes.Tab}
            label={pageLanguageContents?.Arrow_Payment[30]?.MembershipSubscription}
            {...a11yProps(2)}
          />}
        </Tabs>
      </AppBar>

      {/* seller remittance related tab */}
      {!disableFlg && <TabPanel className={classes.TabPanels} value={value} index={0}>
        <div className="tab-content">
          <Heading>Account Details:</Heading>
        </div>
        {pageData?.sellerPaymentDetails?.bankDetails?.length > 0 && (
          <>
            {pageData?.sellerPaymentDetails?.bankDetails?.map((value, index) => (
              <Details key={index}>
                <Row>
                  <p>Account Holder Name</p>
                  <p>{value.name}</p>
                </Row>
                <Row>
                  <p>{pageLanguageContents?.Arrow_Payment[7]?.AcctNo}</p>
                  <p>**** **** **** {value.last4Digit}</p>
                </Row>
                <Row>
                  <p>{pageLanguageContents?.Arrow_Payment[8]?.RountingNo}</p>
                  <p>**** **** **** {value.routingNumber}</p>
                </Row>
                <Edit style={{ marginRight: "30px" }}>
                  {value.defaultPayment &&
                    <Default
                      style={{ "padding-top": "4px", fontWeight: 'bold' }}
                      className="edit-btn">Default</Default>
                  }
                  {(!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP') &&
                    <SetDefault
                      style={{ "padding-top": "4px", "padding-right": "10px", cursor: "pointer", fontWeight: 'bold' }}
                      className="edit-btn"
                      onClick={() => {
                        defaultPaymentCallBack(value.id);
                      }}
                    >
                      Set Default
                    </SetDefault>
                  }
                  {(!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP' && (((pageData?.buyerPaymentDetails?.achDetails?.length || 0) + (pageData?.buyerPaymentDetails?.cardDetails?.length || 0)) > 1)) &&
                    deleteAccount('bankAcc', value)}
                </Edit>
              </Details>
            ))}
          </>
        )}
        <div className="tab-content">
          {pageData?.sellerPaymentDetails?.cardDetails?.length > 0 && (
            <>
              {pageData?.sellerPaymentDetails?.cardDetails.map((value, index) => (
                <Details key={index}>
                  <div className="cc-details-row">
                    {
                      <div className="cc-card">
                        <div className="inner-card-detail">
                          <div>
                            <img
                              className="visa-image"
                              src={getCardImageSourceFunction(value.brandName)}
                              alt="visa-image"
                            />
                          </div>
                          <div>
                            <h4>{value.name || 'name'}</h4>
                            <p>{value.brandName + " ending in " + value.last4Digit + " , expires " + value.expMonth + "/" + value.expYear}</p>
                          </div>
                        </div>
                        <Edit>
                          <span
                            style={{ "padding-right": "10px", "padding-top": "4px", cursor: "pointer", fontWeight: 'bold' }}
                            className="edit-btn"
                            onClick={() => {
                              if (!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP') defaultPaymentCallBack(value.id);
                            }}
                          >
                            {value.defaultPayment ? 'Default' : pageData?.userDetails?.locationType !== 'DEP' ? 'Set Default' : ''}
                          </span>
                          {/* {pageData?.userDetails?.locationType !== 'DEP' &&
                            <div
                              className="account-edit-icon"
                              style={{ "margin-top": "3px" }}
                              onClick={() => {
                                setIndividual();
                                setPopupType("Seller");
                                setAccountResponse(value);
                                addDebitCardToggleModal();
                              }}
                            >
                              <span className="edit-btn">
                                {pageLanguageContents?.Arrow_Payment[25]?.Edit}
                              </span>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", width: "18px", marginleft: "10px", marginTop: "-5px", marginLeft: "3px" }}
                                onClick={(e) => { }}
                              ></img>
                            </div>
                          } */}
                          {(!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP' && (((pageData?.sellerPaymentDetails?.bankDetails?.length || 0) + (pageData?.sellerPaymentDetails?.cardDetails?.length || 0)) > 1)) &&
                            deleteAccount('SellerCard', value)}
                        </Edit>
                      </div>
                    }
                  </div>
                </Details>
              ))}
            </>
          )}
        </div>
        {(pageData?.userDetails?.locationType !== 'DEP' && pageData?.userDetails?.userRole !== 'BUYER') &&
          <Edit>
            <button
              onClick={() => {
                setIndividual("Individual");
                addBankCardToggleModal();
              }}
              className="app-green-button button"
            >
              {pageLanguageContents?.Arrow_Payment[17]?.Button}
            </button>
          </Edit>
        }
      </TabPanel>}

      {/* buyer payment related tab */}
      <TabPanel className={classes.TabPanels} value={value} index={1}>
        <div className="tab-content">
          <><div class="tab-heading">Credit/Debit Card Details:</div></>

          {pageData?.buyerPaymentDetails?.achDetails?.length > 0 && (
            <>
              {pageData?.buyerPaymentDetails?.achDetails?.map((value, index) => (
                <Details key={index}>
                  <Row>
                    <p>Account Holder Name</p>
                    <p>{value.name}</p>
                  </Row>
                  <Row>
                    <p>{pageLanguageContents?.Arrow_Payment[7]?.AcctNo}</p>
                    <p>**** **** **** {value.last4Digit}</p>
                  </Row>
                  <Row>
                    <p>{pageLanguageContents?.Arrow_Payment[8]?.RountingNo}</p>
                    <p>**** **** **** {value.routingNumber}</p>
                  </Row>
                  <Edit style={{ marginRight: "22px" }}>
                    <span
                      style={{ paddingRight: "10px", paddingTop: "4px", cursor: "pointer", fontWeight: 'bold' }}
                      className="edit-btn"
                      onClick={() => {
                        if (!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP') defaultPaymentCallBack(value.id);
                      }}
                    >
                      {value.defaultPayment ? 'Default' : (pageData?.userDetails?.locationType !== 'DEP' && value.verified) ? 'Set Default' : ''}
                    </span>
                    {(!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP' && (((pageData?.buyerPaymentDetails?.achDetails?.length || 0) + (pageData?.buyerPaymentDetails?.cardDetails?.length || 0)) > 1)) &&
                      deleteAccount('ACHAccount', value)}
                  </Edit>

                  {!value.verified ?
                    <>
                      {pageData?.userDetails?.locationType !== 'DEP' ?
                        <>
                          <Edit>
                            <button
                              disabled={value.noOfAttemptsRemaining === 0}
                              onClick={() => {
                                setSelectedAchAccountForVerify(value)
                                verifyToggleModal()
                              }}
                              className="app-green-button button"
                            >
                              Verify
                            </button>
                          </Edit>
                          {value.noOfAttemptsRemaining === 0 ?
                            <span style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>You have exceeded the allowed number of attempts.</span>
                            :
                            <span style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>Attempt(s) left :  {value.noOfAttemptsRemaining}</span>
                          }
                        </>
                        :
                        ''}
                    </>
                    :
                    <VerifyWrapper>
                      <p>Verified</p>
                    </VerifyWrapper>}
                </Details>
              ))}
            </>
          )}

          {pageData?.buyerPaymentDetails?.cardDetails?.length > 0 && (
            <>
              {pageData?.buyerPaymentDetails?.cardDetails?.map((value, index) => (
                <Details key={index}>
                  <div className="cc-details-row">
                    {
                      <div className='cc-card'>
                        <div className='inner-card-detail'>
                          <div>
                            <img
                              className="visa-image"
                              src={getCardImageSourceFunction(value.brandName)}
                              alt="visa-image"
                            />
                          </div>
                          <div>
                            <h4>{value.name || 'name'}</h4>
                            <p>{value.brandName + " ending in " + value.last4Digit + " , expires " + value.expMonth + "/" + value.expYear}</p>
                          </div>
                        </div>

                        <div className="editDelete">
                          <span
                            style={{ paddingRight: "10px", cursor: "pointer", fontWeight: 'bold', marginTop: "3px" }}
                            className="edit-btn"
                            onClick={() => {
                              if (!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP') defaultPaymentCallBack(value.id);
                            }}
                          >
                            {value.defaultPayment ? 'Default' : pageData?.userDetails?.locationType !== 'DEP' ? 'Set Default' : ''}
                          </span>
                          {pageData?.userDetails?.locationType !== 'DEP' &&
                            <div
                              className="account-edit-icon"
                              style={{ "margin-top": "3px" }}
                              onClick={() => {
                                setIndividual();
                                setPopupType("Buyer");
                                setAccountResponse(value);
                                addDebitCardToggleModal();
                              }}
                            >
                              <span className="edit-btn">
                                {pageLanguageContents?.Arrow_Payment[25]?.Edit}
                              </span>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", width: "18px", marginleft: "10px", marginTop: "-5px", marginLeft: "3px" }}
                                onClick={(e) => { }}
                              ></img>
                            </div>
                          }
                          {(!value.defaultPayment && pageData?.userDetails?.locationType !== 'DEP' && (((pageData?.buyerPaymentDetails?.achDetails?.length || 0) + (pageData?.buyerPaymentDetails?.cardDetails?.length || 0)) > 1)) &&
                            deleteAccount('BuyerCard', value)}
                        </div>
                      </div>
                    }
                  </div>
                </Details>
              ))}
            </>
          )}
          {(pageData?.userDetails?.locationType !== 'DEP' && pageData?.userDetails?.userRole !== 'SELLER') &&
            <Edit>
              <button
                onClick={() => {
                  // setIndividual('')
                  pageData?.userDetails?.locationType === 'INDEPENDENT' ? setIndividual("Individual") : setIndividual('')
                  setPaymentType();
                  addCardToggleModal();
                }}
                className="app-green-button button"
              >
                {pageLanguageContents?.Arrow_Payment[17]?.Button}
              </button>
            </Edit>
          }
        </div>
      </TabPanel>

      {/* Subscription card details */}
      {!disableFlg && <TabPanel className={classes.TabPanels} value={value} index={2}>
        {!disableFlg && <>
          <div className="tab-content">
            <Heading>
              {pageData?.promoCode2?.length > 0
                ? `Benefit Period valid for ${pageData.promoCode2[0].timeSpanForBenefits.number} 
                ${pageData.promoCode2[0].timeSpanForBenefits?.timeDMY}(s) of Subscription, Ending ${pageData &&
                moment(pageData?.subscriptionEndDate).format(FORMAT)}`
                : `Subscription End Date: ${moment(pageData?.subscriptionEndDate).format(FORMAT)}`}
            </Heading>
            <div>
              <EditDiv>
                <p>{pageLanguageContents?.Arrow_Payment[14]?.SubCard}{" "}</p>
              </EditDiv>
              {pageData?.subscriptionDetails ? (
                <Details>
                  <div className="cc-details-row">
                    {
                      <div className="cc-card">
                        <div className="inner-card-detail">
                          <div>
                            <img
                              className="visa-image"
                              src={getCardImageSourceFunction(pageData?.subscriptionDetails?.brandName)}
                              alt="visa-image"
                            />
                          </div>
                          <div>
                            <h4>{pageData?.subscriptionDetails?.name || 'Name'}</h4>
                            <p>{pageData?.subscriptionDetails?.brandName + " ending in " + pageData?.subscriptionDetails?.last4Digit +
                              " , expires " + pageData?.subscriptionDetails?.expMonth + "/" + pageData?.subscriptionDetails?.expYear}
                            </p>
                          </div>
                        </div>
                        {/* {pageData?.userDetails?.locationType !== 'DEP' && */}
                        {pageData?.userDetails?.locationType === 'MAIN' && pageData?.accountType === "CORPORATE_ADMIN" &&
                          <div className="editDelete">
                            <div
                              className="account-edit-icon"
                              onClick={() => {
                                setIndividual();
                                setAccountResponse(pageData?.subscriptionDetails);
                                addDebitCardToggleModal();
                              }}
                            >
                              <span className="edit-btn">
                                {pageLanguageContents?.Arrow_Payment[25]?.Edit}
                              </span>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", width: "18px", marginleft: "10px", }}
                                onClick={(e) => { }}
                              ></img>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </Details>
              ) : (
                <p>{pageLanguageContents?.Arrow_Payment[15]?.NA}</p>
              )}

              {/* {pageData?.userDetails?.locationType !== 'DEP' && */}
              {pageData?.userDetails?.locationType === 'MAIN' && pageData?.accountType === "CORPORATE_ADMIN" &&
                <Edit>
                  <button
                    onClick={() => {
                      setIndividual();
                      setPaymentType("subscriptionsPayment");
                      addCardToggleModal();
                    }}
                    className="app-green-button button"
                  >
                    {pageLanguageContents?.Arrow_Payment[17]?.Button}
                  </button>
                </Edit>
              }
            </div>
          </div>
          <Separator></Separator>
          <div className="tab-content"></div>
        </>
        }
      </TabPanel>}

      {addBankCardmodal &&
        <BankACForm
          pageData={pageData}
          modalType={'sellerRemittanceDetailsAdd'}
          isOpen={addBankCardmodal}
          toggle={addBankCardToggleModal}
          individual={individual}
          callBackModal={() => {
            setAddBankCardmodal(false);
            callBackFetchApi();
          }}
          onClickHander={(val) => {
            setAddBankCardmodal(false);
            if (val === "payment") {
              callBackFetchApi();
            }
          }}
        />
      }
      {verifyModal &&
        <VerifyModal
          isOpen={verifyModal}
          toggle={verifyToggleModal}
          title=""
          selectedAchAccountForVerify={selectedAchAccountForVerify}
          individual={individual}
          callBackModal={(result) => {
            callBackFetchApi()
            verifyToggleModal()
          }}
          accountResponse={accountResponse}
          onClickHander={(val) => {
            setAddBankCardmodal(false)
            if (val === "payment") {
              callBackFetchApi()
            }

          }}
          content=""
          link=""
        />
      }
      {addDebitCardmodal &&
        <DebitForm
          isOpen={addDebitCardmodal}
          toggle={addDebitCardToggleModal}
          title=""
          popupType={popupType}
          accountResponse={accountResponse}
          onClickHander={(val) => {
            addDebitCardToggleModal();
            if (val === "payment") {
              callBackFetchApi();
            }
          }}
          content=""
          link=""
        />
      }
      {addCardmodal &&
        <AddCardPopup
          isOpen={addCardmodal}
          toggle={addCardToggleModal}
          modalType={paymentType === 'subscriptionsPayment' ? 'newSubscriptionAdd' : 'buyerPaymentDetailsAdd'}
          title=""
          pageData={pageData}
          callBackFetchApi={() => {
            setAddCardmodal(!addCardmodal)
            callBackFetchApi()
          }}
          onClickHander={(val) => {
            setAddCardmodal(!addCardmodal)
          }}
          content=""
          pageLanguageContents={pageLanguageContents}
        />
      }

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType=''
        callBackAlert={() => {
        }}
      />

      <DeleteModal
        isOpen={deleteModal}
        toggle={toggleDeletModal}
        actionType={actionType}
        onChangeHandler={(val) => {
          if (val === 'Yes') {
            deletePaymentMethod(val)
          } else {
            toggleDeletModal()
          }
        }}
        link={setModalDeleteLink}
      />
    </div>
  );
};
export default PaymentTabs;

const SetDefault = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  padding: 8px 0;
`;
const Default = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
`;
const Edit = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
  button {
    width: 167px;
  }
  p {
    cursor: pointer;
    color: #2525ed;
    line-height: 1.79;
    font-size: 14px;
    width: fit-content;
    margin: 0;
  }
`;
const EditDiv = styled.div`
  display: flex;
  p {
    display: flex;
  }
  /* div{
      padding: 0 29px;
    } */
`;
const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 25px;
  margin-top: 15px;
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  .editDelete {
    display: flex;
    > .edit-btn {
      font-weight: bolder;
    }
  }
  .delete-icon {
    max-width: 22px;
    cursor: pointer;
    margin-left: 15px;
  }
`;
const Heading = styled.div`
  font-size: 16px;
  font-weight: bold;
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  > div {
    font-weight: normal;
  }
  .account-edit-icon {
    display: flex;
    align-items: center;
    .edit-btn {
      display: inline-flex;
      cursor: pointer;
    }
    /* @media (max-width: 600px) {
      .edit-btn {
        display: none;
      }
    } */
  }
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 0 29px;
  position: relative;
  .account-edit-icon {
    display: flex;
    align-items: center;
    .edit-btn {
      display: inline-flex;
      cursor: pointer;
    }
    @media (max-width: 600px) {
      .edit-btn {
        display: none;
      }
    }
  }
  p {
    &:first-child {
      line-height: 1.79;
      font-size: 14px;
      flex: 1;
      max-width: 245px;
    }
    &:nth-child(2) {
      line-height: 1.67;
      font-family: "latobold";
      color: #000000;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  /* div{
      padding: 0 29px;
    } */
  @media (max-width: 766px) {
    padding: 0;
    justify-content: space-between;
    p {
      &:first-child {
        line-height: 1.79;
        font-size: 14px;
        flex: 1;
        max-width: 245px;
      }
    }
  }
`;

const PromoCodeSection = styled.div`
  position: absolute;
  display: inline-flex;
  top: 6px;
  right: 8px;
  cursor: pointer;
  div {
    background: transparent;
    color: #61ae24;
    width: auto;
    text-decoration: underline;
  }
`;

const PromocCodeWrapper = styled.div`
  position: relative;
  .app-input-text input {
    padding-right: 58px;
  }
`;
const VerifyWrapper = styled.div`
  display: flex;
  justify-content: end;
  p {
    width: 167px;
    padding: 6px;
    background: #61b01f;
    border-radius: 5px;
    color: white;
    text-align: center;
  } 
`;